import { memo } from 'react'

import Image from 'next/legacy/image'

import Box from '@ilg-totallymoney/ui/components/Box'

import backgroundIntroGclModal from '@images/bg-intro-gcl-modal.png'

const BackgroundBlob = memo(function Blob() {
    return (
        <Box
            top={0}
            left={0}
            zIndex={-1}
            bottom={0}
            position="absolute"
            overflow="hidden"
            borderRadius="borderRadius20"
            width="100%"
        >
            <Image
                src={backgroundIntroGclModal}
                layout="fill"
                alt="Background blob"
            />
        </Box>
    )
})

export default BackgroundBlob
